var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"authorizationWrapper"},[(!_vm.cordova)?_c('topheader',{attrs:{"back":"main"}}):_vm._e(),_c('div',{staticClass:"brandWrapper"},[_c('logotype',{attrs:{"big":true}})],1),_c('signin')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }